import * as z from 'zod';

export const industryQueryBaseSchema = z.object({
  id: z.number(),
  name: z.string(),
});

export type IndustryQueryBaseSchema = z.infer<typeof industryQueryBaseSchema>;
